import React from 'react'
import { Form, Input, Checkbox, Button, Popconfirm} from 'antd';

class ContributorDetails extends React.Component {
  constructor(props) {
    super(props)
    this.state = { modified: false }
    //this.state.modified = false
    //this.state.currentData = this.props.contributor
    this.handleCancel = this.handleCancel.bind(this)
  }


  handleValuesChange = (e) => {
    if (!this.state.modified) {
      this.setState({ modified: true })
    }
    if (e.target.id === "contributor_lastName") {

    }

  }

  handleCancel = () => {
    this.setState({ modified: false })
    //console.log("contributor: " + this.props.contributor.displayName)
    let contributor = this.props.contributor
    this.props.form.setFieldsValue({
      city: contributor.city,
      suburb: contributor.suburb,
      phone: contributor.phone,
      offeringNo: contributor.offeringNo,
      lastName: contributor.lastName,
      firstName: contributor.firstName,
      displayName: contributor.displayName,
      postcode: contributor.postcode,
      country: contributor.country,
      address: contributor.address,
      email: contributor.email,
      requireReceipt: contributor.requireReceipt

    })
  }

  handleSubmit = (e) => {
    e.preventDefault();
    //console.log("submitting contributor...");
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let newValues = { ...this.props.contributor, ...values }
        if (newValues.id === -1) {
          this.props.saveNew(newValues)
        }
        else {
          this.props.saveChanges(newValues)
        }
        //console.log("form values: ", newValues);
        //this.setState({ Organization: newValues })
      } else {
        console.error(err)
      }
    })
  }

  handleDelete = (e) => {
    e.preventDefault();
    let id = this.props.contributor.id 
    this.props.deleteContributor(id) 
  }

  handledOnFocus(e) {
    e.preventDefault = true
    //console.log(e.target.name)
    if (e.target.id && e.target.id === "contributor_displayName") {
      let displayName = this.props.form.getFieldValue("displayName")
      if (displayName === "") {
        let firstName = this.props.form.getFieldValue("firstName")
        let lastName = this.props.form.getFieldValue("lastName")
        this.props.form.setFieldsValue({ displayName: firstName + " " + lastName, } )
      }
    }
  }


  render() {
   // const ButtonGroup = Button.Group;
    let contributor = this.props.contributor
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    //const formTailLayout = {
    //  labelCol: { span: 4 },
    //  wrapperCol: { span: 4, offset: 6 },
    //};
//    <Button shape="circle" icon="user" style={{ float: 'right' }} />


    return (

      <Form autoComplete="nope" className="side-form" onSubmit={this.handleSubmit} >
        <div className="panel"  style={{ padding: 10 }}>
          <h4>{contributor.displayName}</h4>
          </div>
        <Form.Item {...formItemLayout} label="Offering No:">
          {getFieldDecorator('offeringNo', {
            initialValue: contributor.offeringNo,
            rules: [{
              required: true,
              message: 'Offering No is compulsory'
            }]
          })(
            <Input autoComplete="nope" onChange={(e) => { this.handleValuesChange(e) }} />
          )}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Last Name:">
          {getFieldDecorator('lastName', {
            initialValue: contributor.lastName,
            rules: [{
              required: true,
              message: 'Last Name is compulsory'
            }]
          })(
            <Input autoComplete="nope" onChange={(e) => { this.handleValuesChange(e) }} />
          )}
        </Form.Item>
        <Form.Item {...formItemLayout} label="First Name:">
          {getFieldDecorator('firstName', {
            initialValue: contributor.firstName
          })(
            <Input autoComplete="nope" onChange={(e) => { this.handleValuesChange(e) }} />
          )}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Display Name:">
          {getFieldDecorator('displayName', {
            initialValue: contributor.displayName,
            rules: [{
              required: true,
              message: 'Display Name is compulsory'
            }]
          })(
            <Input autoComplete="nope" onFocus={(e) => { this.handledOnFocus(e) } } onChange={(e) => { this.handleValuesChange(e) }} />
          )}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Address:">
          {getFieldDecorator('address', {
            initialValue: contributor.address
          })(
            <Input autoComplete="nope" onChange={(e) => { this.handleValuesChange(e) }} />
          )}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Suburb:">
          {getFieldDecorator('suburb', {
            initialValue: contributor.suburb
          })(
            <Input autoComplete="nope" onChange={(e) => { this.handleValuesChange(e) }} />
          )}
        </Form.Item>
        <Form.Item {...formItemLayout} label="City:">
          {getFieldDecorator('city', {
            initialValue: contributor.city
          })(
            <Input autoComplete="nope" onChange={(e) => { this.handleValuesChange(e) }} />
          )}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Country:">
          {getFieldDecorator('country', {
            initialValue: contributor.country
          })(
            <Input autoComplete="nope" onChange={(e) => { this.handleValuesChange(e) }} />
          )}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Postcode:">
          {getFieldDecorator('postcode', {
            initialValue: contributor.postcode
          })(
            <Input autoComplete="nope" onChange={(e) => { this.handleValuesChange(e) }} />
          )}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Phone:">
          {getFieldDecorator('phone', {
            initialValue: contributor.phone
          })(
            <Input autoComplete="nope" onChange={(e) => { this.handleValuesChange(e) }} />
          )}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Email:">
          {getFieldDecorator('email', {
            initialValue: contributor.email
          })(
            <Input autoComplete="nope" onChange={(e) => { this.handleValuesChange(e) }} />
          )}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Require Receipt?:">
          {getFieldDecorator('requireReceipt', {
            valuePropName: 'checked',
            initialValue: contributor.requireReceipt
          })(
            <Checkbox autoComplete="nope" onChange={(e) => { this.handleValuesChange(e) }} />
          )}
        </Form.Item>
        <Form.Item
          wrapperCol={{ span: 12, offset: 6 }} >
          <Button icon="save" type="primary" disabled={!this.state.modified} htmlType="submit" style={{ margin: '0px 5px 0px 0px' }}>
            Save
          </Button>
          {/*<Button  disabled={!this.state.modified} type="primary" onClick={this.handleCancel} style={{ margin: '0px 5px 0px 0px' }}>
            Cancel
          </Button> */}
          <Popconfirm
            title="Are you sure delete this contributor?"
            onConfirm={this.handleDelete}
            okText="Yes"
            cancelText="No">
          <Button icon="delete" disabled={this.state.modified || this.props.contributor.contributionCount } type="danger" >
            Delete
          </Button>
            </Popconfirm>
        </Form.Item>
      </Form>

    )
  }

}


const FormContributor = Form.create({ name: 'contributor' })(ContributorDetails);
export default FormContributor;

